import { useEffect, useState } from "react";
import QRCode from "qrcode";

export function Qr({ value, size = 240 }: { value: string; size?: number }) {
  const [src, setSrc] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    QRCode.toDataURL(value, {
      width: size * 2,
      margin: 1,
      errorCorrectionLevel: "M",
    }).then((url) => {
      if (!cancelled) setSrc(url);
    });
    return () => {
      cancelled = true;
    };
  }, [value, size]);

  if (!src) {
    return <div className="qr qr-placeholder" style={{ width: size, height: size }} />;
  }
  return (
    <img
      className="qr"
      src={src}
      width={size}
      height={size}
      alt={`QR-Code: ${value}`}
    />
  );
}
